export enum ActiveStatus {
  Running = "running", // Indicates that the status is running.
  Paused = "paused", // Indicates that the status is paused.
  Holiday = "holiday", // Indicates that the status is set to holiday.
}
